import axios from '../http'

function query(data) {
    return axios.post('/event/race/query', data);
}


function get(id) {
    return axios.get('/event/race/get?id=' + id);
}

  
function init(id) {
    return axios.get('/event/race/init?id=' + id);
}


function rank(id) {
    return axios.get('/event/race/rank?id=' + id);
}

function cancel(id) {
    return axios.get('/event/race/cancel?id=' + id);
}

function printStartOrder(id) {
    const url = "/event/race/printStartOrder?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const pdfUrl = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf;charset=UTF-8'}));
        const newWindow = window.open(pdfUrl);
        window.URL.revokeObjectURL(newWindow);
    })
}

function printMediaStartOrder(id) {
    const url = "/event/race/printMediaStartOrder?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const pdfUrl = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf;charset=UTF-8'}));
        const newWindow = window.open(pdfUrl);
        window.URL.revokeObjectURL(newWindow);
    })
}

function exportStartOrder(id){
    const url =  "/event/race/exportStartOrder?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(res);
            link.download = "Start List by Race.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
}

function printResultOrder(id) {
    const url = "/event/race/printResultOrder?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const pdfUrl = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf;charset=UTF-8'}));
        const newWindow = window.open(pdfUrl);
        window.URL.revokeObjectURL(newWindow);
    })
}
function exportResultOrder(id){
    const url =  "/event/race/exportResultOrder?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(res);
            link.download = "Results by Race.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
}

export default {
    query,
    get,
    init,
    rank,
    printStartOrder,
    printMediaStartOrder,
    exportStartOrder,
    exportResultOrder,
    printResultOrder,
    cancel
}